import { transcribe, meeting as meetingModel, barrage } from '@/models';
import { Lang } from '@/types/lang';
import webModels from '@/web/models';
import { useLocalStore, useObserver } from 'mobx-react';
import { useCallback, useEffect, useState } from 'react';

export const useTranscribe = () => {
  const [loading, setLoading] = useState<boolean>(false);
  const { transcribeStomp } = useLocalStore(() => webModels);
  const meeting = useLocalStore(() => meetingModel);
  const [subscribeId, setSubscriptionId] = useState<string>();
  const [subscribeDes, setSubscribeDes] = useState<string>();
  const [resMsg, setResMsg] = useState<any>();

  const { channelId } = useObserver(() => {
    return {
      channelId: meeting.info?.channelId,
    };
  });

  const connect = useCallback((linked: boolean) => {
    setLoading(true);
    transcribeStomp.setStartedConnected(linked);
  }, []);
  // useEffect(() => {
  //   window.addEventListener('beforeunload', () => {
  //     console.log('beforeunload-stomp---disconnect');
  //     stomp.disconnect();
  //   });
  // }, []);
  // 拿到会议idchannelId 开始建立stomp链接

  useEffect(() => {
    if (transcribe.translate) {
      const translate = transcribe.targetLang === Lang.auto ? false : true;
      const translateTargetLanguage =
        transcribe.targetLang === Lang.auto ? '' : transcribe.targetLang;

      API.api.webSubtitleV3.switchTranscriptionLanguage
        .request(
          { meetingId: window.$meetingId },
          {
            channelId,
            language: transcribe.originLang,
            translate,
            translateTargetLanguage,
          }
        )
        .then((res) => {
          if (res && res.status === 1) {
            const { stompDestination } = res.data;
            transcribeStomp.unSubscribe(subscribeId);
            setSubscribeDes(stompDestination);
            setSubscriptionId(`${+new Date()}`);
          }
        });
    }
  }, [transcribe.originLang, transcribe.translate, transcribe.targetLang]);

  const initConnect = useCallback(() => {
    console.log('转录调用initConnect');
    transcribeStomp.initConnect(() => {
      console.log('---transcribe.translate', transcribe.translate);
      console.log('subscribeId', subscribeId);
      if (transcribe.translate) {
        const translate = transcribe.targetLang === Lang.auto ? false : true;
        const translateTargetLanguage =
          transcribe.targetLang === Lang.auto ? '' : transcribe.targetLang;
        return API.api.webSubtitleV3.switchTranscriptionLanguage
          .request(
            { meetingId: window.$meetingId },
            {
              channelId,
              language: transcribe.originLang,
              translate,
              translateTargetLanguage,
            }
          )
          .then((res) => {
            if (res && res.status === 1) {
              const { stompDestination } = res.data;
              if (subscribeId) {
                transcribeStomp.unSubscribe(subscribeId);
              }
              setSubscribeDes(stompDestination);
              setSubscriptionId(`${+new Date()}`);
              return res;
            }
          });
      }
      return API.api.webSubtitleV3.getStompAuth
        .request({ meetingId: window.$meetingId, channelId: channelId })
        .then((res) => {
          if (res.status === 1) {
            const { stompDestination } = res.data;
            const id = `${+new Date()}`;
            if (subscribeId) {
              transcribeStomp.unSubscribe(subscribeId);
            }
            setSubscriptionId(id);
            setSubscribeDes(stompDestination);
            return res;
          }
        });
    });
  }, [transcribe, channelId, subscribeId, transcribe.translate]);

  useEffect(() => {
    if (subscribeDes && transcribeStomp.connected && subscribeId)
      setTimeout(() => {
        transcribeStomp.subscribe(
          subscribeDes,
          (data: any) => {
            setResMsg(data);
          },
          subscribeId
        );
      }, 500);
  }, [transcribeStomp.connected, subscribeDes, subscribeId]);

  useEffect(() => {
    if (transcribe.transcribeVisible && transcribeStomp.startedConnected && channelId) {
      initConnect();
    }
  }, [transcribeStomp.startedConnected, transcribe.transcribeVisible, channelId]);

  useEffect(() => {
    if (!transcribe.transcribeVisible) {
      subscribeId && transcribeStomp?.unSubscribe(subscribeId);
      transcribeStomp.disconnect();
      setSubscribeDes('');
      setSubscriptionId('');
    }
  }, [transcribe.transcribeVisible]);

  return useObserver(() => {
    return {
      connect,
      resMsg,
      connected: transcribeStomp.connected,
    };
  });
};
